import i18nFactory from '@yandex-int/i18n';

import { RegionCode } from '../../typings/constants';
import { RegionsEditorCommonNodeInfoForQuickSelectItem } from '../../typings/regionsEditor';

import * as keyset from './regions.i18n';

const i18n = i18nFactory(keyset);

export const quickSelectItemsRegionsEditor: RegionsEditorCommonNodeInfoForQuickSelectItem[] = [
    {
        title: i18n('moscow-region'),
        nodeIds: [RegionCode.MOSCOW_REGION]
    },
    {
        title: i18n('leningrad-region'),
        nodeIds: [RegionCode.LENINGRAD_REGION]
    },
    {
        title: i18n('ukraine'),
        nodeIds: [RegionCode.UKRAINE]
    },
    {
        title: i18n('russia-cis-georgia'),
        nodeIds: [RegionCode.RUSSIA, RegionCode.CIS, RegionCode.GEORGIA]
    }
];
